/* American Fitness — Theme JS · Lot 014 */
(() => {
  'use strict';

  // ── Nav drawer ──────────────────────────────
  const navBtn    = document.getElementById('nav-drawer-btn');
  const navDrawer = document.getElementById('nav-drawer');
  const navClose  = document.getElementById('nav-drawer-close');

  function openNav() {
    navDrawer.classList.add('is-open');
    navDrawer.setAttribute('aria-hidden', 'false');
    navBtn && navBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    navDrawer.classList.remove('is-open');
    navDrawer.setAttribute('aria-hidden', 'true');
    navBtn && navBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  navBtn   && navBtn.addEventListener('click', openNav);
  navClose && navClose.addEventListener('click', closeNav);

  // ── Cart drawer ─────────────────────────────
  const cartBtn     = document.getElementById('cart-drawer-btn');
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose   = document.getElementById('cart-drawer-close');

  function openCart() {
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartBtn && cartBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartBtn && cartBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  cartBtn     && cartBtn.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  cartClose   && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // ── Cart qty buttons ─────────────────────────
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('.cart-qty-btn');
    const removeBtn = e.target.closest('.cart-remove-btn');

    if (qtyBtn) {
      const key     = qtyBtn.dataset.key;
      const action  = qtyBtn.dataset.action;
      const item    = qtyBtn.closest('.cart-item');
      const qtyEl   = item.querySelector('span');
      const current = parseInt(qtyEl.textContent.trim(), 10);
      const newQty  = action === 'increment' ? current + 1 : Math.max(0, current - 1);

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty }),
        });
        const cart = await res.json();
        updateCartUI(cart);
      } catch (err) {
        console.error('Cart update failed', err);
      }
    }

    if (removeBtn) {
      const key = removeBtn.dataset.key;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        const cart = await res.json();
        updateCartUI(cart);
      } catch (err) {
        console.error('Cart remove failed', err);
      }
    }
  });

  // ── Add to cart (PDP) ────────────────────────
  const pdpForm = document.querySelector('.pdp__atc form, form[id^="product-form-"]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = pdpForm.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      try {
        const fd = new FormData(pdpForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }),
        });
        await res.json();
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartUI(cart);
        openCart();
      } catch (err) {
        console.error('Add to cart failed', err);
      } finally {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  }

  // ── Update cart UI counts + subtotal + items ──
  function updateCartUI(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.dataset.cartCount = cart.item_count;
    });
    const subtotal = document.getElementById('cart-subtotal');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    const itemsEl = document.getElementById('cart-drawer-items');
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<p style="font-family:\'JetBrains Mono\',monospace;font-size:14px;letter-spacing:0.2em;text-transform:uppercase;opacity:0.5;margin-top:32px;">YOUR BAG IS EMPTY.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__img" src="${item.image || ''}" alt="${item.title || ''}" width="80" height="80">
        <div>
          <div class="cart-item__title">${item.product_title || item.title || ''}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__footer">
            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
            <div class="cart-item__qty">
              <button class="cart-qty-btn" data-action="decrement" data-key="${item.key}" aria-label="Remove one">−</button>
              <span>${item.quantity}</span>
              <button class="cart-qty-btn" data-action="increment" data-key="${item.key}" aria-label="Add one">+</button>
            </div>
            <button class="cart-remove-btn" data-key="${item.key}" aria-label="Remove item">✕</button>
          </div>
        </div>
      </div>
    `).join('');
  }

  function formatMoney(cents) {
    const n = parseInt(cents, 10);
    if (isNaN(n)) return '$0.00';
    return '$' + (n / 100).toFixed(2);
  }

  // ── Sync cart on page load ───────────────────
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartUI(cart))
    .catch(() => {});

  // ── PDP: variant switching ───────────────────
  const variantData = document.querySelector('[id^="product-variants-"]');
  if (variantData) {
    const variants    = JSON.parse(variantData.textContent);
    const variantInput = document.getElementById('pdp-variant-id');
    const formInput    = document.getElementById('pdp-variant-id-form');
    const priceEl      = document.getElementById('pdp-price');
    const compareEl    = document.getElementById('pdp-compare-price');
    const atcBtn       = document.getElementById('pdp-atc-btn');

    const initialId = variantInput ? String(variantInput.value) : '';
    const initial   = variants.find(v => String(v.id) === initialId) || variants[0];
    let selectedOptions = initial ? [...initial.options] : [];

    document.querySelectorAll('.pdp__variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.optionIndex, 10);
        selectedOptions[idx] = btn.dataset.value;

        const group = btn.closest('.opt-block') || btn.parentElement;
        group.querySelectorAll('.pdp__variant-btn').forEach(b => {
          b.classList.toggle('active', b === btn);
        });

        const match = variants.find(v =>
          v.options.every((o, i) => selectedOptions[i] === null || o === selectedOptions[i])
        );

        if (!match) {
          if (atcBtn) {
            atcBtn.textContent = 'UNAVAILABLE';
            atcBtn.disabled = true;
          }
          return;
        }

        if (variantInput) variantInput.value = match.id;
        if (formInput) formInput.value = match.id;
        if (window.history && history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState(null, '', url.toString());
        }
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          compareEl.textContent = match.compare_at_price > match.price
            ? formatMoney(match.compare_at_price) : '';
        }
        if (atcBtn) {
          if (match.available) {
            atcBtn.textContent = 'ADD TO CART';
            atcBtn.disabled = false;
          } else {
            atcBtn.textContent = 'SOLD OUT';
            atcBtn.disabled = true;
          }
        }

        // swap gallery image to variant's featured image
        if (match.featured_image) {
          const featuredImg = document.getElementById('pdp-featured-img');
          if (featuredImg) {
            const src = match.featured_image.src
              .replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_1200x$1$3');
            featuredImg.src = src;
            const matchThumb = pdpThumbs.find(t =>
              t.dataset.src && t.dataset.src.includes(
                match.featured_image.src.split('/').pop().split('?')[0].split('.')[0]
              )
            );
            if (matchThumb) {
              pdpThumbs.forEach(t => t.classList.remove('active'));
              matchThumb.classList.add('active');
            }
          }
        }
      });
    });
  }

  // ── PDP: image gallery ───────────────────────
  const pdpThumbs = Array.from(document.querySelectorAll('.pdp__thumb'));

  function getVisibleThumbs() {
    const isMobile = window.innerWidth <= 600;
    const hasMobileImgs = pdpThumbs.some(t => t.dataset.mobile === 'true');
    if (!hasMobileImgs) return pdpThumbs;
    return isMobile
      ? pdpThumbs.filter(t => t.dataset.mobile === 'true')
      : pdpThumbs.filter(t => t.dataset.mobile !== 'true');
  }

  function pdpActivate(thumb) {
    const featured = document.getElementById('pdp-featured-img');
    if (!thumb || !featured) return;
    featured.src = thumb.dataset.src;
    pdpThumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  }

  // init: activate first visible thumb
  const firstVisible = getVisibleThumbs()[0];
  if (firstVisible) pdpActivate(firstVisible);

  pdpThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => pdpActivate(thumb));
  });

  const prevBtn = document.getElementById('pdp-prev');
  const nextBtn = document.getElementById('pdp-next');
  if (prevBtn) prevBtn.addEventListener('click', () => {
    const visible = getVisibleThumbs();
    const cur = visible.findIndex(t => t.classList.contains('active'));
    pdpActivate(visible[cur <= 0 ? visible.length - 1 : cur - 1]);
  });
  if (nextBtn) nextBtn.addEventListener('click', () => {
    const visible = getVisibleThumbs();
    const cur = visible.findIndex(t => t.classList.contains('active'));
    pdpActivate(visible[cur >= visible.length - 1 ? 0 : cur + 1]);
  });

  // ── Spec video controls ──────────────────────
  document.querySelectorAll('.spec-video-play').forEach(btn => {
    const video = document.getElementById(btn.dataset.video);
    if (!video) return;
    btn.addEventListener('click', () => {
      const playIcon  = btn.querySelector('.spec-video-play__icon');
      const pauseIcon = btn.querySelector('.spec-video-pause__icon');
      if (video.paused) {
        video.play();
        playIcon.style.display  = 'none';
        pauseIcon.style.display = '';
      } else {
        video.pause();
        playIcon.style.display  = '';
        pauseIcon.style.display = 'none';
      }
    });
    video.addEventListener('play',  () => { btn.querySelector('.spec-video-play__icon').style.display = 'none'; btn.querySelector('.spec-video-pause__icon').style.display = ''; });
    video.addEventListener('pause', () => { btn.querySelector('.spec-video-play__icon').style.display = ''; btn.querySelector('.spec-video-pause__icon').style.display = 'none'; });
  });

  document.querySelectorAll('.spec-video-vol').forEach(btn => {
    const video = document.getElementById(btn.dataset.video);
    if (!video) return;
    btn.addEventListener('click', () => {
      video.muted = !video.muted;
      btn.querySelector('.spec-video-mute__icon').style.display   = video.muted ? '' : 'none';
      btn.querySelector('.spec-video-unmute__icon').style.display = video.muted ? 'none' : '';
    });
  });

  // ── Mobile nav drawer ───────────────────────
  const mobileNavBtn    = document.getElementById('mobile-nav-btn');
  const mobileNavDrawer = document.getElementById('mobile-nav-drawer');

  function openMobileNav() {
    if (!mobileNavDrawer) return;
    mobileNavDrawer.classList.add('is-open');
    mobileNavDrawer.setAttribute('aria-hidden', 'false');
    mobileNavBtn && mobileNavBtn.classList.add('is-open');
    mobileNavBtn && mobileNavBtn.setAttribute('aria-expanded', 'true');
  }
  function closeMobileNav() {
    if (!mobileNavDrawer) return;
    mobileNavDrawer.classList.remove('is-open');
    mobileNavDrawer.setAttribute('aria-hidden', 'true');
    mobileNavBtn && mobileNavBtn.classList.remove('is-open');
    mobileNavBtn && mobileNavBtn.setAttribute('aria-expanded', 'false');
  }
  function toggleMobileNav() {
    mobileNavDrawer && mobileNavDrawer.classList.contains('is-open')
      ? closeMobileNav()
      : openMobileNav();
  }

  mobileNavBtn && mobileNavBtn.addEventListener('click', toggleMobileNav);

  // ── Shop collection filter ───────────────────
  function applyCollectionFilter(filter) {
    document.querySelectorAll('.shop-sidebar__link[data-filter]').forEach(b => b.classList.remove('is-active'));
    const activeBtn = document.querySelector(`.shop-sidebar__link[data-filter="${filter}"]`);
    if (activeBtn) activeBtn.classList.add('is-active');
    document.querySelectorAll('.shop-group').forEach(group => {
      group.style.display = (filter === 'all' || group.id === 'group-' + filter) ? '' : 'none';
    });
  }

  document.querySelectorAll('.shop-sidebar__link[data-filter]').forEach(btn => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.filter;
      applyCollectionFilter(filter);
      const url = filter === 'all'
        ? window.location.pathname
        : window.location.pathname + '?group=' + filter;
      history.replaceState(null, '', url);
    });
  });

  // Initialize filter from URL on page load
  const urlGroup = new URLSearchParams(window.location.search).get('group');
  if (urlGroup) applyCollectionFilter(urlGroup);

  // ── Keyboard close ───────────────────────────
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeNav();
      closeCart();
      closeMobileNav();
      closeLightbox();
    }
  });

  // ── Image lightbox (tap/click to open, pinch-zoom + pan) ──
  const lightbox = document.createElement('div');
  lightbox.className = 'pdp-lightbox';
  lightbox.innerHTML = `
    <button class="pdp-lightbox__close" aria-label="Close">✕</button>
    <img class="pdp-lightbox__img" src="" alt="">
    <div class="pdp-lightbox__hint">PINCH TO ZOOM · DRAG TO PAN</div>
  `;
  document.body.appendChild(lightbox);

  const lbImg   = lightbox.querySelector('.pdp-lightbox__img');
  const lbClose = lightbox.querySelector('.pdp-lightbox__close');
  const lbHint  = lightbox.querySelector('.pdp-lightbox__hint');

  let lbScale = 1, lbX = 0, lbY = 0;
  let lbPinching = false, lbLastDist = 0;
  let lbDragStartX = 0, lbDragStartY = 0;
  let lbMoved = false;
  let lbLastTap = 0;

  function openLightbox(src) {
    lbImg.src = src;
    lbScale = 1; lbX = 0; lbY = 0;
    applyLbTransform();
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lbHint.style.opacity = '1';
    setTimeout(() => { lbHint.style.transition = 'opacity 0.5s'; lbHint.style.opacity = '0'; }, 2000);
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function applyLbTransform() {
    lbImg.style.transform = `translate(${lbX}px, ${lbY}px) scale(${lbScale})`;
  }

  function clampPan() {
    const rect = lbImg.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    const overX = Math.max(0, (rect.width  - vw)  / 2);
    const overY = Math.max(0, (rect.height - vh) / 2);
    lbX = Math.min(overX, Math.max(-overX, lbX));
    lbY = Math.min(overY, Math.max(-overY, lbY));
  }

  lightbox.addEventListener('touchstart', (e) => {
    if (e.touches.length === 2) {
      lbPinching = true;
      lbLastDist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
    } else if (e.touches.length === 1) {
      lbDragStartX = e.touches[0].clientX - lbX;
      lbDragStartY = e.touches[0].clientY - lbY;
      lbMoved = false;
      // double-tap to zoom
      const now = Date.now();
      if (now - lbLastTap < 300) {
        if (lbScale > 1) { lbScale = 1; lbX = 0; lbY = 0; }
        else             { lbScale = 2.5; }
        applyLbTransform();
      }
      lbLastTap = now;
    }
  }, { passive: true });

  lightbox.addEventListener('touchmove', (e) => {
    e.preventDefault();
    if (e.touches.length === 2 && lbPinching) {
      const dist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      lbScale = Math.min(5, Math.max(1, lbScale * (dist / lbLastDist)));
      lbLastDist = dist;
      clampPan();
      applyLbTransform();
    } else if (e.touches.length === 1 && !lbPinching) {
      if (lbScale > 1) {
        lbX = e.touches[0].clientX - lbDragStartX;
        lbY = e.touches[0].clientY - lbDragStartY;
        clampPan();
        applyLbTransform();
      }
      lbMoved = true;
    }
  }, { passive: false });

  lightbox.addEventListener('touchend', (e) => {
    if (e.touches.length < 2) lbPinching = false;
    if (lbScale < 1.05) { lbScale = 1; lbX = 0; lbY = 0; applyLbTransform(); }
  }, { passive: true });

  // close on background tap (no drag, not pinch)
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox && !lbMoved) closeLightbox();
  });
  lbClose.addEventListener('click', closeLightbox);

  // open on featured image click/tap
  const featuredImgEl = document.getElementById('pdp-featured-img');
  if (featuredImgEl) {
    featuredImgEl.addEventListener('click', () => openLightbox(featuredImgEl.src));
  }

  // open on field image tap
  document.querySelectorAll('.pdp-field__tile img').forEach(img => {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', () => openLightbox(img.src));
  });
})();
